/* eslint react/no-unused-prop-types: 0 */
import _uniqBy from 'lodash/uniqBy';
import _isObject from 'lodash/isObject';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _toNumber from 'lodash/toNumber';
import _conforms from 'lodash/conforms';
import _debounce from 'lodash/debounce';
import _findIndex from 'lodash/findIndex';
import _find from 'lodash/find';
import _get from 'lodash/get';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { contactByEmail } from '../actions/action-contact-option';
import { updateFinalContactOptions } from '../actions/index';
import ContactOption from '../components/ContactOption';
import contentHelper from '../../lib/contentHelper';
import { callusMessage } from '../../lib/messageHelper';
import { loadModalContainer } from '../actions/action-login-modal';
import { locationUpdate } from '../actions/action-contact-location';
import { initiateRiskCheck, resetStepUp } from '../actions/action-step-up';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import l10n from '../../lib/reactPPl10nHelper';
import { getEstimateWaitTime } from '../../lib/asyncMessageHelper';
import { isFinalIntent } from '../../lib/step-up-helper';
import {
  isNodeChatAlreadyExists,
  filterC3MarketsConfig,
  returnChannelsFromC3MerchantRC,
  isC2MerchantMigrated, validateAMFlag, getC3MerchantMigrationConfig,
} from '../../lib/globalHelper';
import { setChatCardClickInSession } from '../../lib/chat-bot-live-helper';
import { filterCallUsFromChannels, isSuppressCallUs } from '../../lib/covidHelper';

import { showHideCovidBcpModalAlert } from '../actions/action-covid-modal-alert';
import { requestLoggedOutChatValidation } from '../../lib/loggedOutChatHelper';
import { requestPuiTopicValidation } from '../../lib/puiTopicHelper';
import {
  SELECT_RESULT, AVAILABLE_DECISION, CONTACT_OPTION, LEXA_STATE, CALL_US_PHONE_INFO,
} from '../constants/PropTypesShapes';

const chatHeaderDefault = i18n.message('smarthelp/contactOption.disableIcon.defaultOptionShort');
const chatHeaderfinalIntent = i18n.message('smarthelp/contactOption.chat.message.finalIntent');
const messageHeader = l10n.getContent('smarthelp/contactOption.messageUs.header');
const messageText = l10n.getContent('smarthelp/contactOption.messageUs.text');

const finalIntentRecommendedHeading = i18n.message('smarthelp/contactLinksOption.message.recommendedHeading');
const secondaryHeading = l10n.getContent('smarthelp/contactLinksOption.message.secondaryHeading');

const RecommendChannel = {
  chat: l10n.getContent('smarthelp/contactLinksOption.message.chatLabel'),
  email: l10n.getContent('smarthelp/contactLinksOption.message.emailLabel'),
  seller: l10n.getContent('smarthelp/contactLinksOption.message.rescenterLabel'),
  callus: l10n.getContent('smarthelp/contactLinksOption.message.callLabel'),
  community: l10n.getContent('smarthelp/contactLinksOption.message.communityLabel'),
  message: l10n.getContent('smarthelp/contactLinksOption.message.messageUsLabel'),
};

const resolution = {
  label: i18n.message('smarthelp/contactLinksOption.label.resolution'),
  message: i18n.message('smarthelp/contactLinksOption.messageLabel.resolution.issues'),
  link: Page.getResolutionURL(),
};

const defaultChatDecision = Page.getDefaultChatDecision();

const ChannelType = {
  CALLUS: 'callus',
  COMMUNITY: 'community',
  EMAIL: 'email',
  CHAT: 'chat',
  CHATBOT: 'chatbot',
  RESOLUTION: 'seller',
};
const lexaChatEligibility = Page.getIsIDIContactOptions();

export class ContactOptionsContainer extends Component {
  // Error case initial state
  static errorContactChannels() {
    // TODO:: temporary suppress callUs for BCP COVID
    // const callUs = {
    //   type: 'callus',
    // };
    const communityOptions = {
      type: 'community',
    };
    return Page.getCommunitySearchURL() ? [communityOptions] : [];
  }

  static FPTIClickTracking(link) {
    trackLink({ id: 'contactUsPage', link });
  }

  // Line break rule for contact panels
  static contactPanelsLineBreak(contactOptions) {
    const contactOptionNum = contactOptions.length;
    return classNames({
      'contact-panels': true,
      'contact-panels-four-padding': contactOptionNum === 4,
      'contact-panels-five-padding': contactOptionNum === 5,
    });
  }

  // get the Maximum priority from contact options
  static getMaximumPriority(channels) {
    const maxChannel = channels.reduce((prev, current) => ((Number(prev.priority) > Number(current.priority)) ? prev : current));
    return Number(maxChannel.priority);
  }

  // Adding chat option to the end of the channels array
  static appendChannel(contactChannels, channel) {
    const channels = [...contactChannels];
    const nextIndex = (ContactOptionsContainer.getMaximumPriority(contactChannels) + 1);
    channels.push({ type: channel, priority: nextIndex.toString() });
    return channels;
  }

  // Adding chat option to the beginning of the channels array
  static prependChannel(contactChannels, channel) {
    let channels = [...contactChannels];
    channels = channels.map((channelItem) => ({
      type: channelItem.type,
      priority: (Number(channelItem.priority) + 1).toString(),
    }));
    channels.unshift({ type: channel, priority: '1' });
    return channels;
  }

  static getChatOptionIndex(channels) {
    return _findIndex(channels, (contactOption) => contactOption.type === 'chat');
  }

  static hasMessageOption(channels) {
    return _findIndex(channels, (channel) => channel.type === 'message') >= 0;
  }

  // remove contact option base on the channel name
  static filterOutChannels(contactChannels, channelName) {
    return contactChannels.filter((contactChannel) => contactChannel.type !== channelName);
  }

  // remove contact option duplicate key
  static removeContactDuplicate(contactOptions) {
    return _uniqBy(contactOptions, 'type');
  }

  static getRecoHeader(heading) {
    return (
      <div className="call-header">
        { heading }
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.emailMessage = isC2MerchantMigrated() ? props.content.emailUs.merchantMigratedResponseTime : callusMessage(props.content.emailUs.loggedOutMessage, props.content.emailUs.loggedInMessage);
    this.contactMessage = props.content.callUs.loggedInMessage;
    this.state = {
      isLoggedIn: document.body.getAttribute('isloggedin'),
    };

    this.showChat = this.showChat.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hasFinalContactOptions && this.isChatEnabled() && nextProps.redirectToChannel) {
      trackPage({ id: 'contactUsPage', link: 'chat-shown' });
    }
  }

  getSearchTerm() {
    return this.props.selectResult ? `${this.props.selectResult.topicRefId}` : '';
  }

  getCommunityMessage() {
    return this.props.activeCommunityUserCount > 0 ? contentHelper(this.props.content.community.online, { onlineMember: this.props.activeCommunityUserCount }) : '';
  }

  getChatMessage() {
    let estimateWaitTime = '';
    if (_isEmpty(this.props.selectResult)) { // Default contact options from `wait_time_to_availability` in the channelDecisions
      estimateWaitTime = _get(defaultChatDecision, 'wait_time_to_availability.wait_period', '');
    } else if (lexaChatEligibility) { // Final contact option with Lexa Chat option information
      estimateWaitTime = this.getLexaChatEWT();
    }

    return estimateWaitTime ? contentHelper(this.props.content.chat.waitTime, { time: getEstimateWaitTime(estimateWaitTime) }) : null;
  }

  getCommunityAction(rank) {
    Page.removeSession('showContactOptions');
    const searchTerm = this.props.selectResult ? `${this.props.selectResult.topicName}` : '';
    this.contactOptionFPTI({ rank, channel: 'community' });
    if (searchTerm) {
      return window.open(contentHelper(Page.getCommunitySearchURL(), { searchTerm }));
    }
    return window.open(Page.getCommunityLink());
  }

  // Event handler for clicking resolution icon
  getResolutionAction(rank) {
    this.contactOptionFPTI({ rank, channel: 'resolution' });

    return window.open(resolution.link, '_blank');
  }

  getMessageUsAction(rank) {
    // If a chat window is already opened Fire an FPTI chat-already-open and return.
    if (isNodeChatAlreadyExists()) {
      return ContactOptionsContainer.FPTIClickTracking('smarthelp-contact-option-selection|chat-already-open');
    }

    // making chatcard clicked true after user clicks on messageus icon since it failed to make users click on it.
    setChatCardClickInSession(true);

    this.contactOptionFPTI({ rank, channel: 'message' });
    return this.props.initiateRiskCheck('messageUs', this.props.selectResult, false);
  }

  getChannelAction(channelName, rank) {
    switch (channelName) {
      case 'email':
        return () => {
          if (this.props.selectResult) {
            return this.showEmailUs(rank);
          }
          return this.showEmailUsNoIntent(rank);
        };
      case 'callus':
        return () => {
          this.showCallUs(rank);
        };
      case 'community':
        return () => {
          this.getCommunityAction(rank);
        };
      case 'chat': {
        // Avoid double clicked issue in Live Chat
        const debouncedShowChat = _debounce(this.showChat, 1000);
        return debouncedShowChat(rank, this.props.selectResult);
      }
      case 'seller':
        return () => {
          this.getResolutionAction(rank);
        };
      case 'message':
        return () => {
          this.getMessageUsAction(rank);
        };
      default:
        return () => {};
    }
  }

  getRecommendChannelName(link) {
    let channelName = this.sortContactChannels();
    // If there is no contact option get from API, then using [callus, community] as default case
    if (Array.isArray(channelName) && channelName.length === 0) {
      channelName = ContactOptionsContainer.errorContactChannels();
    }

    if (_isObject(this.props.selectResult) && Array.isArray(channelName) && channelName.length > 0) {
      return `${link}|rec-${channelName[0].type}`;
    }
    return link;
  }

  getContactChannel(channelName, index, flag) {
    const recommended = index === 0 && _isObject(this.props.selectResult);
    const datapaClick = `contact-option-${channelName}|index-${index}|${this.props.selectResult ? this.props.selectResult.topicRefId : ''}`;
    switch (channelName) {
      case 'email': {
        return (
          <ContactOption
            key="email"
            id="contact-email-option"
            datapaClick={datapaClick}
            contactLinkCSS="btn vx_btn-link contact-link"
            iconClass="vx_btn-link icon-emailus"
            text={this.props.content.emailUs.header}
            message={(this.isCompaintEnabled() || this.isPayPalMeSelected()) ? '' : this.emailMessage}
            supportMessageCSS="support-message"
            clickAction={this.getChannelAction('email', index)}
            recommended={recommended && flag}
          />
        );
      }
      case 'callus': {
        return (
          <ContactOption
            key="callus"
            id="contact-callus-option"
            datapaClick={datapaClick}
            contactLinkCSS="btn vx_btn-link contact-link"
            iconClass="vx_btn-link icon-callus"
            text={this.props.content.callUs.header}
            message={this.contactMessage}
            supportMessageCSS="support-message"
            clickAction={this.getChannelAction('callus', index)}
            recommended={recommended && flag}
          />
        );
      }
      case 'community':
        return (
          <ContactOption
            key="community"
            id="contact-community-option"
            datapaClick={datapaClick}
            iconClass="vx_btn-link icon-community"
            contactLinkCSS="btn vx_btn-link contact-link"
            text={this.props.content.community.header}
            message={this.getCommunityMessage()}
            supportMessageCSS="support-message"
            clickAction={this.getChannelAction('community', index)}
            recommended={recommended && flag}
          />
        );
      case 'chat': {
        const ischatIconEnable = this.ischatIconEnabled();
        if (ischatIconEnable && typeof ischatIconEnable === 'object') {
          return (
            <ContactOption
              key="chat"
              id="contact-chat-option"
              datapaClick={datapaClick}
              iconClass={ischatIconEnable.chatIcon}
              contactLinkCSS={ischatIconEnable.iconCSS}
              text={this.props.content.chat.header}
              message={ischatIconEnable.chatMessage}
              supportMessageCSS="support-message"
              clickAction={this.isChatEnabled() ? () => this.getChannelAction('chat', index) : ''}
              recommended={recommended && flag}
              tabIndex={!this.isChatEnabled() ? -1 : 0}
            />
          );
        }
        return null;
      }
      case 'seller':
        return (
          <ContactOption
            key="resolution"
            id="contact-resolution-option"
            datapaClick={datapaClick}
            contactLinkCSS="btn vx_btn-link contact-link"
            iconClass="vx_btn-link icon-resolution"
            text={resolution.label}
            message={resolution.message}
            supportMessageCSS="support-message"
            clickAction={this.getChannelAction('seller', index)}
            recommended={recommended && flag}
          />
        );
      case 'message':
        return (
          <ContactOption
            key="message"
            id="contact-message-option"
            datapaClick={datapaClick}
            contactLinkCSS="btn vx_btn-link contact-link"
            iconClass="vx_btn-link icon-chat"
            text={messageHeader}
            message={messageText}
            supportMessageCSS="support-message"
            clickAction={this.getChannelAction('message', index)}
            recommended={recommended && flag}
          />
        );
      default:
        return <div />;
    }
  }

  getContent() {
    let content = null;
    if ((this.props.display && this.props.layer === 1) || this.props.reachToResult) {
      // making the contact channels header as static
      let heading = '';
      if (!heading) {
        heading = this.props.selectResult ? this.props.content.header : this.props.content.alterHeader;
      }
      let tempOptions = ContactOptionsContainer.removeContactDuplicate(this.getContactChannelResult());
      let contactOptionsClassName = 'contact-options';
      // checking if the market is enabled in c3merchantMigration RC or
      // if user is isC2MerchantMigrated
      if (filterC3MarketsConfig()) {
        // check for channels in the same remote config
        tempOptions = tempOptions.filter((contact) => (returnChannelsFromC3MerchantRC().indexOf(contact.type)) !== -1);
        contactOptionsClassName = 'contact-options filter-channels';
      }

      // Filtering callus channel for covidnonidi
      tempOptions = this.filterBcpNonIdiMarkets(tempOptions);

      content = (
        <div>
          <div className="col-xs-0 col-sm-1 col-md-1 col-lg-1" />
          <div className={`${contactOptionsClassName} col-xs-12 col-sm-10 col-md-10 col-lg-10`}>
            {(this.props.selectResult) ? null : ContactOptionsContainer.getRecoHeader(heading)}
            {this.renderContactChannels(tempOptions)}
          </div>
        </div>
      );
    }
    return content;
  }

  // Display IDI contact option when IDI option is availabel and reach to topic node leaf selection
  getContactOptionsChannel() {
    // COVID BCP LOGIC
    // If market is IDI enabled execute idi logic
    // If market is not idi enabled and is part to COVID effected RC list then check for EBS
    // IF EBS is high priority enable callUs if not suppress callUs
    const contactChannels = this.props.contactChannels;
    if (Page.isLoggedIn() && !Page.getIsIDIContactOptions()) {
      if (isSuppressCallUs()) {
        return filterCallUsFromChannels(contactChannels);
      }
      return contactChannels;
    }

    // To check the email option exist from the SAC
    const emailOptionValidate = Array.isArray(this.props.formFields) && this.props.formFields.length > 0;
    /**
     * Filter out:
     * 1) the email option in the IDI, if the email form data not in the SAC
     * 2) Empty IDI object
     */
    const IDIContactChannels = _filter(this.props.IDIContactChannels, (channel) => (
      !((channel.type === ChannelType.EMAIL && !emailOptionValidate) || _isEmpty(channel))
    ));

    if (this.props.IDIEnable && Array.isArray(IDIContactChannels) && IDIContactChannels.length > 0 && this.props.reachToResult) {
      return IDIContactChannels;
    }

    // Short term solution COVID-19
    // for Non IDI markets or if IDI error remove callUs from contact options.
    if ((Page.getIsBcpNonIdiEnabledMarket() || this.props.IDIError) && (!isC2MerchantMigrated())) {
      if (Array.isArray(contactChannels) && contactChannels.length) {
        return filterCallUsFromChannels(contactChannels);
      }
      return [];
    }

    return contactChannels;
  }

  // Get contact Channel
  getContactChannelResult() {
    let filteredContactChannels = this.filterContactChannels();
    if (this.isFinishedLoading() && Array.isArray(filteredContactChannels) && filteredContactChannels.length === 0) {
      filteredContactChannels = ContactOptionsContainer.errorContactChannels();
    }
    this.trackFinalContactOptions(filteredContactChannels);
    return filteredContactChannels;
  }

  // Get Chat eligibility detail from lexa/IDI contact options
  getChatAvailability() {
    return _find(this.props.IDIAvailability, (decision) => decision.name === 'CHAT');
  }

  // Get Chat estimate wait time from lexa/IDI contact options
  getLexaChatEWT() {
    const chatDecision = this.getChatAvailability();
    return chatDecision && chatDecision.wait_time_to_availability && chatDecision.wait_time_to_availability.wait_period;
  }

  isLexaChatEnabled() {
    const chatDecision = this.getChatAvailability();
    return lexaChatEligibility && chatDecision && chatDecision.availability_decision === 'AVAILABLE';
  }

  isShowLexaGreyoutChat() {
    const chatDecision = this.getChatAvailability();
    return lexaChatEligibility && chatDecision && chatDecision.availability_decision === 'DELAYED_AVAILABLE';
  }

  isRemoveLexaChat() {
    const chatDecision = this.getChatAvailability();
    return lexaChatEligibility && chatDecision && (chatDecision.availability_decision !== 'AVAILABLE' && chatDecision.availability_decision !== 'DELAYED_AVAILABLE');
  }

  filterBcpNonIdiMarkets(channels) {
    const { contactInfo } = this.props;

    const amPhoneNumber = contactInfo && contactInfo.Account_Manager_Phone_Number;
    const amEmail = contactInfo && contactInfo.Account_Manager_Email_Address;

    // filtering callus if market is present in covidnonidi market
    // Short term update to remove callUs from contact options for BCP COVID-19 non idi enabled markets.
    // This is based in the bcp non idi enabled markets in remote config.
    // and filter  only if AM flag is not available in the callus response
    if (Page.getIsBcpNonIdiEnabledMarket() && !isC2MerchantMigrated() && !amPhoneNumber && !amEmail) { // exception for C2 Migrated merchant
      return channels.filter((channel) => channel.type !== ChannelType.CALLUS);
    }

    return channels;
  }

  /**
   * trackFinalContactOptions sends the FPTI event for final topic intent contact option:
   * (To avoid contact option rerender issue, showing contact option after IDI and SAC service finished loading)
   * 1. has Select Result;
   * 2. SAC finished loaded;
   * 3. if IDI enable, IDI need finished;
   * 4. no finalContactOptions has be set; (To avoid UI rerender; avoid duplicate FPTI)
   * 5. Chat eligibility is not loading
   */
  trackFinalContactOptions(channels) {
    const hasSelectResult = !_isEmpty(this.props.selectResult);
    const isFinalResult = hasSelectResult && this.isFinishedLoading() && !this.props.hasFinalContactOptions;
    let contactChannels = [...channels];

    if (lexaChatEligibility) {
      if (isFinalResult && this.isShowLexaGreyoutChat()) {
        contactChannels = contactChannels.filter((channel) => channel.type !== 'chat');
        contactChannels = ContactOptionsContainer.appendChannel(contactChannels, 'liveChatGrayedOut');
      }
    }

    // Filtering callus channel in fpti for covidnonidi
    contactChannels = this.filterBcpNonIdiMarkets(contactChannels);

    if (isFinalResult) {
      this.props.updateFinalContactOptions(contactChannels); // sending FPTI event for tracking final contact options
    }
  }

  // Append Chat options when grey out chat remote config enabled
  addingChatOption(channels) {
    // Keep Chat option appending for default contact option
    if (_isEmpty(this.props.selectResult)) {
      return this.chatOptionInChannels(channels);
    } if (this.isShowLexaGreyoutChat()) { // If the Lexa chat eligibility is equal to `DELAYED_AVAILABLE`, then remove the chat and append the greyout chat option in the last option
      const filteredOutChannel = ContactOptionsContainer.filterOutChannels(channels, 'chat');
      return this.contactOptionAddChat(filteredOutChannel);
    } if (this.isRemoveLexaChat()) { // Remove Live Chat option, if the decision is not equal to AVAILABLE or DELAYED_AVAILABLE
      return ContactOptionsContainer.filterOutChannels(channels, 'chat');
    }
    return channels;
  }

  // Check Message Us option is validate for the final Intent
  isAsyncChatEnable() {
    return this.props.lexaMessage && this.props.lexaMessage.loaded && this.props.lexaMessage.available;
  }

  contactOptionAddChat(channels) {
    if (_isEmpty(this.props.selectResult)) { // prepend Grey out chat as the first contact option for default contact options (without topic select result)
      return ContactOptionsContainer.prependChannel(channels, 'chat');
    }
    return ContactOptionsContainer.appendChannel(channels, 'chat');
  }

  // Default Chat contact option update
  chatOptionInChannels(channels) {
    const chatIndex = ContactOptionsContainer.getChatOptionIndex(channels); // Check whether chat option exist or not
    const hasGreyOutChat = defaultChatDecision && defaultChatDecision.availability_decision === 'DELAYED_AVAILABLE';

    // If the user is pilot user, no chat option, chat is enable or containing greyout chat, then return contact options
    if (Page.isPilotUser() || chatIndex < 0 || this.isChatEnabled() || hasGreyOutChat) {
      return channels;
    }

    // Remove chat option, if the chat availability is not available
    return ContactOptionsContainer.filterOutChannels(channels, 'chat');
  }

  // ischatIconEnabled: Checking conditions to show enabled or disable chat-icon
  ischatIconEnabled() {
    // Show Enable option for the final intent/default contact options and chat eligibility is true
    if (this.isChatEnabled()) {
      return {
        chatIcon: 'vx_btn-link icon-chat',
        iconCSS: 'btn vx_btn-link contact-link',
        chatMessage: this.getChatMessage(),
      };
    }

    return {
      chatIcon: 'vx_btn-link disable-icon-chat',
      iconCSS: 'btn vx_btn-link disable-contact-link',
      chatMessage: !this.props.hasFinalContactOptions ? chatHeaderDefault : chatHeaderfinalIntent,
    };
  }

  isChatEnabled() {
    // Chat eligibility for default contact option
    if (_isEmpty(this.props.selectResult)) {
      return defaultChatDecision && defaultChatDecision.availability_decision === 'AVAILABLE';
    }

    return this.isLexaChatEnabled(); // get Chat eligibility from lexa/IDI service of the final intent
  }

  isCompaintEnabled() {
    return Page.isComplaintEnabledMarket() && Page.isLoggedIn() && this.props.topicTreeSelectionL1Reference === 'formal_complaints_l1' && this.props.selectResult;
  }

  // To check if PAYPAL Me topic is selected.
  isPayPalMeSelected() {
    return Page.isLoggedIn() && this.props.selectResult && typeof this.props.selectResult.topicRefId === 'string' && this.props.selectResult.topicRefId.trim() === 'PAYPALME001';
  }

  // Checker whether both SAC and IDI contact option are finished loading
  isFinishedLoading() {
    if (!Page.getIsIDIContactOptions()) {
      return this.props.isSACLoaded;
    }
    return this.props.isSACLoaded && this.props.IDIIsLoaded;
  }

  // Todo:: Check this function usage and purpose before removing.
  trackFPTIIncompletedFlow(link) {
    let trackingLink = link;
    if (this.props.topicTreeSelectionL1) {
      trackingLink = `${link}|${this.props.topicTreeSelectionL1}`;
      if (this.props.topicTreeSelectionL2) {
        trackingLink = `${link}|${this.props.topicTreeSelectionL2}`;
      }
    }
    ContactOptionsContainer.FPTIClickTracking(trackingLink);
  }

  contactOptionFPTI({ rank, channel }) {
    const searchTerm = this.getSearchTerm();
    const link = searchTerm && searchTerm !== '' ? `smarthelp-contact-option-selection|${channel}|index-${rank}|${searchTerm}` : `smarthelp-contact-option-selection|${channel}|index-${rank}`;
    ContactOptionsContainer.FPTIClickTracking(this.getRecommendChannelName(link));
  }

  showChat(rank) {
    // If a chat window is already opened Fire an FPTI chat-already-open and return.
    if (isNodeChatAlreadyExists()) {
      return ContactOptionsContainer.FPTIClickTracking('smarthelp-contact-option-selection|chat-already-open');
    }

    // making chat card clicked true after user clicks on chat icon.
    setChatCardClickInSession(true);

    // Fire FPTI
    this.contactOptionFPTI({ rank, channel: 'chat' });

    return this.props.initiateRiskCheck('chat', this.props.selectResult, false);
  }

  // Clicking Call Us channel option in contact-us
  showCallUs(rank) {
    Page.removeSession('showContactOptions');
    this.contactOptionFPTI({ rank, channel: 'call-us' });
    // The RC for EMEA markets determine the countries
    // long term remote config. For markets which are in RC show the login prompt window.
    if (Page.isEmeaMarket()) {
      const isLoginProblem = Page.isNoLoginRequire(this.props.selectResult && this.props.selectResult.topicRefId);

      // If user is not logged in and topic is related to login problems redirect to callUs page.
      if (!Page.isLoggedIn() && isLoginProblem) {
        return this.props.locationUpdate({ pageName: 'callUs' });
      }
    }

    // If is final intent initiateRiskCheck action.
    if (isFinalIntent(this.props.selectResult)) {
      return this.props.initiateRiskCheck('callUs', this.props.selectResult, false);
    }

    // If user is logged in and click on default options callUs
    if (Page.isLoggedIn()) {
      return this.props.locationUpdate({ pageName: 'callUs' });
    }

    return this.props.loadModalContainer('callUs');
  }

  showEmailUsNoIntent(rank) {
    this.contactOptionFPTI({ rank, channel: 'email-us' });
    const c3MerchantMigrationConfig = getC3MerchantMigrationConfig();
    if (isC2MerchantMigrated()) {
      if (c3MerchantMigrationConfig.goPayEnabled) {
        return (() => {
          window.location.href = `${c3MerchantMigrationConfig.goPayEnabledUrl}`;
        })();
      }
      return (() => {
        window.open(`mailto:${c3MerchantMigrationConfig.emailUs}`);
      })();
    }
    if (!this.state.isLoggedIn) {
      // if locale and topic from pui_webform_config rc request additional validation to show email without logged in
      return this.props.loadModalContainer('email');
    } if (Page.isRedirectToSMC()) {
      return Page.redirectToSMC();
    }
    Page.scrollToTop();
    return this.props.locationUpdate({ pageName: 'email' });
  }

  showEmailUs(rank) {
    Page.removeSession('showContactOptions');
    this.contactOptionFPTI({ rank, channel: 'email-us' });
    if (Page.isRedirectToSMC()) {
      return (() => {
        window.open(`/smc/compose?topicId=${this.props.selectResult.topicId}&breadcrumbs=${this.props.breadcrumb.toString()}`, '_self');
      })();
    }

    if (!this.state.isLoggedIn) {
      // enabling chat content on login modal when clicked on email us
      this.props.requestLoggedOutChatValidation(this.props.topicRefId);

      // if locale and topic from pui_webform_config rc request additional validation to show email without logged in
      this.props.requestPuiTopicValidation(this.props.topicRefId);

      return this.props.loadModalContainer('emailUs');
    }

    Page.scrollToTop();
    return this.props.contactByEmail(this.props.formFields);
  }

  filterContactChannels() {
    let contactOptions = this.sortContactChannels();
    contactOptions = _filter(contactOptions,
      _conforms({
        type: (type) => ((Page.getCommunityLink() && Page.getCommunitySearchURL()) || type !== 'community'), // Community filter logic
        // removed Chat option filter logic; as we are not using chat eligibility anymore
      }));

    // filter out Chat and Email options, if the user is Pilot user
    if (Page.isPilotUser()) {
      // Default Contact options
      if (_isEmpty(this.props.selectResult)) {
        contactOptions = _filter(contactOptions, (option) => option.type !== 'chat' && option.type !== 'email');

        // Prepend message option in the default contact options
        contactOptions.unshift({ type: 'message', priority: '0' });
      } else if (ContactOptionsContainer.hasMessageOption(contactOptions)) {
        // Filter out chat in final contact options, if there is message option
        contactOptions = _filter(contactOptions, (option) => option.type !== 'chat');
      }
    } else if (this.props.IDIError || Page.isLexaPilotFailure()) {
      // Remove Email and Chat option, if Lexa IDI received error
      contactOptions = _filter(contactOptions, (option) => option.type !== 'chat' && option.type !== 'email');
    }
    return contactOptions;
  }

  sortContactChannels() {
    const contactOptions = this.addingChatOption(this.getContactOptionsChannel());
    if (contactOptions && Array.isArray(contactOptions)) {
      return contactOptions.sort((channel1, channel2) => (
        _toNumber(channel1.priority) - _toNumber(channel2.priority)
      ));
    }
    return null;
  }

  waitForRenderContactOptions() {
    // No wait, if the SAC finished loading and has error; there will be no KanaCode for IDI service
    if (this.props.reachToResult && this.props.isSACLoaded && this.props.error) {
      return false;
    } if (this.props.reachToResult && (!this.props.isSACLoaded || (Page.getIsIDIContactOptions() && !this.props.IDIIsLoaded))) {
      return true;
    }
    return false;
  }

  renderContacts(tempOptions, flag = true) {
    return (
      <ul className={ContactOptionsContainer.contactPanelsLineBreak(tempOptions)}>
        {tempOptions.map((channel, index) => (
          <li className="contact-option-list-item">
            {this.getContactChannel(channel.type, index, flag)}
          </li>
        ))}
      </ul>
    );
  }

  renderContactPanels(tempOptions) {
    if (this.props.selectResult && tempOptions.length >= 1) {
      const recommendedContact = [tempOptions[0]];
      const recommendedContactName = RecommendChannel[recommendedContact[0].type];
      const recommendedTitle = contentHelper(finalIntentRecommendedHeading, { contactoption: recommendedContactName });
      const restOfContacts = tempOptions.slice(1);
      return (
        <div className="newContactFinalIntentFooter">
          <h2 className="recoTitle">{recommendedTitle}</h2>
          { this.renderContacts(recommendedContact, true) }
          { (tempOptions.length > 1) ? (
            <div>
              <h2 className="recoTitle">{ secondaryHeading }</h2>
              { this.renderContacts(restOfContacts, false) }
            </div>
          ) : null }
        </div>
      );
    }
    return this.renderContacts(tempOptions, true);
  }

  renderContactChannels(tempOptions) {
    return this.renderContactPanels(tempOptions);
  }

  render() {
    if (validateAMFlag()) {
      // for loggedin and non-idi market wait for callus API to load to check the AM flag response to display call option
      if (this.props.callusLoading) {
        return <div />;
      }
      return this.waitForRenderContactOptions() ? null : this.getContent();
    }
    return this.waitForRenderContactOptions() ? null : this.getContent();
  }
}

function mapStateToProps(state) {
  return {
    breadcrumb: state.breadCrumb.items,
    content: window.localeBundle ? window.localeBundle['smarthelp/contactOption'] : {},
    contactChannels: state.contactChannels.channels,
    IDIError: state.contactChannels.IDIError,
    IDIEnable: state.contactChannels.IDIEnable,
    IDIIsLoaded: state.contactChannels.IDIIsLoaded,
    IDIContactChannels: state.contactChannels.IDIChannels,
    IDIAvailability: state.contactChannels.IDIAvailability,
    formFields: state.emailForm.fields,
    display: state.contactChannels.display,
    activeCommunityUserCount: state.activeCommunityUserCount.count,
    selectResult: state.selectResult.topicTreeSelectResult,
    topicsDisplay: state.selectResult.topicsDisplay,
    topicTreeSelectionL1: state.topicTree.topicTreeSelectionL1 ? state.topicTree.topicTreeSelectionL1.topic_name : undefined,
    topicTreeSelectionL2: state.topicTree.topicTreeSelectionL2 ? state.topicTree.topicTreeSelectionL2.topic_name : undefined,
    topicTreeSelectionL1Reference: state.topicTree.topicTreeSelectionL1 ? state.topicTree.topicTreeSelectionL1.ref_id : undefined,
    reachToResult: state.contactChannels.reachToResult,
    isSACLoaded: state.contactChannels.isSACLoaded,
    error: state.contactChannels.error,
    hasFinalContactOptions: state.contactChannels.hasFinalContactOptions,
    layer: state.topicSelect.layer,
    lexaMessage: state.lexaMessage,
    redirectToChannel: state.stepUp.redirectToChannel,
    stepUpFromChannel: state.stepUp.fromChannel,
    topicRefId: state.emailForm.topicRefId,
    callusLoading: state.callUs.isLoading,
    contactInfo: state.callUs.callUsResult && state.callUs.callUsResult.contactInfo,
  };
}

ContactOptionsContainer.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  contactChannels: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)),
  IDIError: PropTypes.bool.isRequired,
  IDIEnable: PropTypes.bool,
  IDIIsLoaded: PropTypes.bool,
  IDIContactChannels: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)),
  IDIAvailability: PropTypes.arrayOf(PropTypes.shape(AVAILABLE_DECISION)),
  formFields: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  activeCommunityUserCount: PropTypes.number,
  locationUpdate: PropTypes.func.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  selectResult: PropTypes.shape(SELECT_RESULT),
  contactByEmail: PropTypes.func.isRequired,
  display: PropTypes.bool,
  topicTreeSelectionL1: PropTypes.string,
  topicTreeSelectionL2: PropTypes.string,
  topicTreeSelectionL1Reference: PropTypes.string,
  reachToResult: PropTypes.bool,
  isSACLoaded: PropTypes.bool,
  error: PropTypes.bool,
  hasFinalContactOptions: PropTypes.bool,
  updateFinalContactOptions: PropTypes.func.isRequired,
  layer: PropTypes.number,
  topicsDisplay: PropTypes.bool,
  lexaMessage: PropTypes.shape(LEXA_STATE).isRequired,
  initiateRiskCheck: PropTypes.func.isRequired,
  resetStepUp: PropTypes.func.isRequired,
  redirectToChannel: PropTypes.bool.isRequired,
  stepUpFromChannel: PropTypes.string.isRequired,
  topicRefId: PropTypes.string,
  requestLoggedOutChatValidation: PropTypes.func.isRequired,
  requestPuiTopicValidation: PropTypes.func.isRequired,
  callusLoading: PropTypes.bool.isRequired,
  contactInfo: PropTypes.shape(CALL_US_PHONE_INFO).isRequired,
};

ContactOptionsContainer.defaultProps = {
  breadcrumb: [],
  contactChannels: [],
  IDIEnable: false,
  IDIIsLoaded: false,
  IDIContactChannels: [],
  IDIAvailability: [],
  formFields: [],
  activeCommunityUserCount: 0,
  selectResult: undefined,
  display: false,
  topicTreeSelectionL1: undefined,
  topicTreeSelectionL2: undefined,
  topicTreeSelectionL1Reference: undefined,
  reachToResult: false,
  isSACLoaded: false,
  error: false,
  hasFinalContactOptions: false,
  layer: 1,
  topicsDisplay: false,
  topicRefId: '',
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    contactByEmail,
    loadModalContainer,
    locationUpdate,
    updateFinalContactOptions,
    initiateRiskCheck,
    resetStepUp,
    showHideCovidBcpModalAlert,
    requestLoggedOutChatValidation,
    requestPuiTopicValidation,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactOptionsContainer);
